import MuiTextField from "@mui/material/TextField";
import InputAdornment from '@mui/material/InputAdornment';
import {
  Button, FormGroup, Grid, Skeleton,
  GridColumn, Heading, Radio, useSnackbar,
  Select
} from "@livingdesign/react";
import { Plus } from "@livingdesign/icons";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { getService, postService } from "../../../../axios/axios";
import MatterAutocomplete from "../../../../components/Autocomplete/MatterAutocomplete/MatterAutocomplete";
import {
  BUDGET_AMOUNT, BUDGET_NAME,
  detailModes as modes,
  ORGANIZATION,
  DESCRIPTION,
  BUDGET_LABELS,
  MATTER,
  CS_SCOPES
} from "../../../../constants/constants";
import { BUDGET_SAVE_MESSAGE, BUDGET_UPDATE_MESSAGE } from "../../../../constants/messages";
import Detail from "../../../Detail/Detail";
import Label from "../../../../components/TextField/Label/Label";
import { BUDGET_SERVICE, COMPOSITE_SEARCH_SERVICE } from "../../../../constants/baseURLs";
import { budgetDetailValidationRules } from "../../../../Validation/validationRules";
import MuiValidationMessage from "../../../../Validation/MuiValidationMessage/MuiValidationMessage";
import { getErrorMessage, getHighestVersion, onInputNumberKeyDown, renderTernary, sortByString } from "../../../../helpers/utils";
import { filterPayload } from "../../../../helpers/commonUtils";
import { REMOVE, SUBMIT, DISCARD, PROCEED } from "../../../../constants/actionButtons";
import UtbmsActivityAutocomplete from "../../../../components/Autocomplete/UtbmsActivityAutocomplete/UtbmsActivityAutocomplete";
import { CreateEditBudgetStyles } from "./CreateEditBudget.styles";
import { getNextTenFiscalYears } from "../../../../helpers/dateTimeUtils";
import SubmitBudgetModal from "../../../../components/Modal/SubmitBudgetModal/SubmitBudgetModal";
import { formCompositeSearchQuery, formCsFilterObject } from "../../../../helpers/csQueryUtils";
import { setVersionDetails } from "../../../../store/actions/budgetActions";
import moment from "moment";

const Title = {
  edit: "Edit Budget",
  create: "Add Budget",
};

let idNum = 0;

const CreateEditBudget = () => {
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [mode, setMode] = useState(null);
  const { matterDetail } = useSelector((state) => state?.matter);
  const { state: { budgetId = "0", fromMatter } = {} } = useLocation();
  const {
    identifier,
    companyName
  } = useSelector((state) => state?.organization?.organizationDetailValues);
  const [budgetTypeLocal, setBudgetTypeLocal] = useState();
  const initialData = {
    budgetType: "Total",
    timePeriod: BUDGET_LABELS.LIFE_OF_MATTER,
    status: "draft",
    startDate: "",
    endDate: "",
    matter: fromMatter ?
      {
        matterName: matterDetail?.matter?.matterName,
        referenceKey: matterDetail?.matter?.matterNumber,
        matterId: matterDetail?.matter?.identifier,
        practiceAreaCode: matterDetail?.matter?.practiceAreaCode
      } : null,
    isInternal: true,
    matterId: fromMatter ? matterDetail?.matter?.identifier : null,
    organization: {},
    budgetName: "",
    budgetAmount: "",
    fiscalYear: ""
  };
  const [title,] = useState({ ...Title });
  const [data, setData] = useState({ ...initialData });
  const [detailData, setDetailData] = useState({});
  const classes = CreateEditBudgetStyles()
  const history = useHistory();
  const dispatch = useDispatch();
  const { addSnack } = useSnackbar();
  const { register, formState: { errors } } = useForm({ mode: "all" });
  const [phaseItemsError, setPhaseItemsError] = useState([]);
  const versionDetails = useSelector(state => state.budget?.versionDetails);
  const [submitModalOpen, setSubmitModalOpen] = useState(false);
  const [existingBudgetData, setExistingBudgetData] = useState();
  const tenYears = getNextTenFiscalYears();
  const masterDetails = useSelector(state => state?.masterData?.masterDatas);
  useEffect(() => {
    if (budgetId === "0") {
      setMode(modes.CREATE);
    } else {
      setMode(modes.EDIT);
    }
  }, [data, budgetId]);

  useEffect(() => {
    if (mode === "edit") {
      getBudgetDetail();
    }
  }, [mode]);

  useEffect(() => {
    if (data?.budgetType?.toLowerCase() === "phase" && !data?.budgetPhases) {
      const addFirstPhaseData = [{
        id: ++idNum,
        new: true,
        code: null,
        displayName: "",
        budgetAmount: "",
      }];
      setData({ ...data, budgetPhases: addFirstPhaseData });
    }
    setBudgetTypeLocal(data?.budgetType)
  }, [data?.budgetType]);

  /*
* This useEffect caters to change in budgetName for every change in timePeriod, organization and fiscal Year
*/
  useEffect(() => {
    let timePeriodLabel;
    if (data?.timePeriod == BUDGET_LABELS.LIFE_OF_MATTER) {
      timePeriodLabel = "LOM"
    } else {
      timePeriodLabel = data?.fiscalYear
    }
    // handleInputChange("budgetName", budgetTypeLocal + "-" + timePeriodLabel + "-" + companyName + "-" + versionDetails)//To-Do
    handleInputChange("budgetName", budgetTypeLocal + "-" + timePeriodLabel + "-" + companyName)
  }, [budgetTypeLocal, data?.timePeriod, data?.organization, data?.fiscalYear, versionDetails])

  /**
   * This function is called when api call throws an error
   */
  const handleError = (error) => {
    setLoading(false);
    addSnack({
      message: getErrorMessage(error),
    });
  }

  const onCloseModal = () => {
    dispatch(setVersionDetails("V1"))
  }
  /**
     * Function to call Budget Service
     */
  const getBudgetDetail = () => {
    setDataLoading(true);
    getService(BUDGET_SERVICE, `/budgets/v1/${budgetId}`)
      .then((res) => {
        const detail = res?.data;
        const matter = { matterName: detail?.matterName, referenceKey: detail?.matterNumber, matterId: detail?.matterId, practiceAreaCode: detail?.practiceAreaCode }
        const organization = { organizationName: detail?.organizationName, referenceKey: detail?.organizationId }
        setData({ ...data, ...detail, matter, organization, budgetType: detail?.type, fiscalYear: `FY${moment(detail?.endDate).year()}` })
        setDetailData({ ...data, ...detail, matter, organization, budgetType: detail?.type });
        setDataLoading(false);
      })
      .catch((error) => {
        setDataLoading(false);
        addSnack({
          message: getErrorMessage(error),
        });
      });
  };

  const setUtbmsCode = (v, id) => {
    handleInputChangeBudgetPhase("code", v, id)
  };

  const handleInputChange = (name, value) => {
    if (name === "budgetAmount" && value !== "" && value < 1) {
      return
    }
    if (name === "budgetAmount" && value !== "" && value > 1) {
      const budgetAmountValue = Math.trunc((parseFloat(value) + Number.EPSILON) * 100) / 100
      setData({ ...data, [name]: budgetAmountValue });
      return
    }
    if (name === "fiscalYear" && value !== "") {
      const startDate = `${Number(value?.slice(2)) - 1}-02-01`;
      const endDate = `${Number(value?.slice(2))}-01-31`;
      setData({ ...data, [name]: value, ["startDate"]: startDate, ["endDate"]: endDate });
      return
    }
    setData({ ...data, [name]: value });
  };

  /**
* Function to call Budget Search Service
* This API call is made to check for any existing Budget which has similar Organization, Matter, Time period and Type with Status Pending/Approved,
* If Exists, the respective details would be shown on Modal
*/
  const onSubmitHandle = () => {
    setLoading(true)
    let additionalFilterQuery = [];

    if (data?.timePeriod === BUDGET_LABELS.CUSTOM_DATE_RANGE_LABEL) {
      const startYear = Number(data?.fiscalYear?.substring(2)) - 1
      const endYear = Number(data?.fiscalYear?.substring(2))
      additionalFilterQuery = [
        formCsFilterObject("startDate", "gte", `${startYear}-01-01 18:29:59`),// 2024
        formCsFilterObject("endDate", "lte", `${endYear}-12-31 18:29:59`)//2025
      ]
    }

    const filterQuery = {
      "filters": [
        formCsFilterObject("status", "in", [BUDGET_LABELS.STATUS_PENDING, BUDGET_LABELS.STATUS_APPROVED]),
        formCsFilterObject("matterId", "match", renderTernary(fromMatter, data?.matterId, data?.matter?.matterId)),
        formCsFilterObject("timePeriod", "match", data?.timePeriod),
        formCsFilterObject("organizationId", "match", identifier),
        ...additionalFilterQuery
      ],
      "operation": "AND",
      "properties": null
    }
    const query = formCompositeSearchQuery([CS_SCOPES.BUDGET], filterQuery);

    postService(
      COMPOSITE_SEARCH_SERVICE,
      `/composite-search/v1?returnCsv=false&organizationId=${identifier}`,
      query
    )
      .then((response) => {
        if (response?.data?.budget?.data?.length > 0) {
          setLoading(false);
          dispatch(setVersionDetails(`V${getHighestVersion(response?.data?.budget?.data) + 1}`))
          setExistingBudgetData(response?.data?.budget?.data)
          setSubmitModalOpen(true)
        } else {
          onCreateHandler()
        }
      })
      .catch((error) => {
        //Silent Failure
        onCreateHandler()
      });
  };

  const onCreateHandler = () => {
    setLoading(true);
    let sparebudgetPhases;
    if (data?.hasOwnProperty("budgetPhases")) {
      sparebudgetPhases = data?.budgetPhases;
      const budgetPhases = data?.budgetPhases?.map((item) => {
        const codes = JSON.parse(item?.code);
        return { ...item, code: codes?.value };
      })
      data.budgetPhases = budgetPhases;
    }
    const body = {
      budgetName: data?.budgetName,
      matterId: fromMatter ? matterDetail?.matter?.identifier : data?.matter?.matterId,
      matterNumber: fromMatter ? matterDetail?.matter?.matterNumber : data?.matter?.referenceKey,
      matterName: fromMatter ? matterDetail?.matter?.matterName : data?.matter?.matterName,
      practiceAreaCode: fromMatter ? matterDetail?.matter?.practiceAreaCode : data?.matter?.practiceAreaCode,
      organizationId: identifier,
      organizationName: companyName,
      timePeriod: data?.timePeriod,
      ...(data?.timePeriod === BUDGET_LABELS?.CUSTOM_DATE_RANGE_LABEL && {
        startDate: data?.startDate ? `${data?.startDate} 00:00:00` : "",
        endDate: data?.endDate ? `${data?.endDate} 23:59:59` : "",
        fiscalYear: data?.fiscalYear
      }),
      type: data?.budgetType,
      budgetAmount: data?.budgetAmount,
      budgetPhases: data?.budgetType?.toLowerCase() === "phase" ? data?.budgetPhases : [],
      isInternal: data?.isInternal,
    };
    const filteredBody = filterPayload(body)
    postService(BUDGET_SERVICE, `/budgets/v1`, filteredBody)
      .then((res) => {
        history.push(`/budget/${res?.data?.id}`, { budgetType: data?.budgetType, fromMatter: fromMatter });
        setLoading(false);
        addSnack({
          message: BUDGET_SAVE_MESSAGE,
        });
      })
      .catch((error) => {
        if (data?.hasOwnProperty("budgetPhases")) {
          data.budgetPhases = sparebudgetPhases;
        }
        handleError(error)
      });
  };

  /**
   * Gets called when clicked on save button.
   */
  const onUpdateHandler = () => {
    setLoading(true);
    let sparebudgetPhases;
    if (data?.hasOwnProperty("budgetPhases")) {
      sparebudgetPhases = data?.budgetPhases;
      const budgetPhases = data?.budgetPhases?.map((item) => {
        if (item?.hasOwnProperty("new") && item?.new) {
          const codes = JSON.parse(item?.code);
          return { ...item, code: codes?.value };
        }
        return item;
      })
      data.budgetPhases = budgetPhases;
    }
    const body = {
      budgetName: data?.budgetName,
      matterId: fromMatter ? matterDetail?.matter?.identifier : data?.matter?.matterId,
      matterNumber: fromMatter ? matterDetail?.matter?.matterNumber : data?.matter?.referenceKey,
      matterName: fromMatter ? matterDetail?.matter?.matterName : data?.matter?.matterName,
      practiceAreaCode: fromMatter ? matterDetail?.matter?.practiceAreaCode : data?.practiceAreaCode,
      organizationId: data?.organization?.referenceKey,
      organizationName: data?.organization?.organizationName,
      timePeriod: data?.timePeriod,
      ...(data?.timePeriod === BUDGET_LABELS?.CUSTOM_DATE_RANGE_LABEL && {
        startDate: data?.startDate ? `${data?.startDate} 00:00:00` : "",
        endDate: data?.endDate ? `${data?.endDate} 23:59:59` : "",
        fiscalYear: data?.fiscalYear
      }),
      type: data?.budgetType,
      budgetAmount: data?.budgetAmount,
      budgetPhases: data?.budgetType?.toLowerCase() === "phase" ? data?.budgetPhases : [],
      isInternal: data?.isInternal,
    };
    const filteredBody = filterPayload(body)
    postService(BUDGET_SERVICE, `/budgets/v1`, filteredBody)
      .then((res) => {
        const newBudgetId = res?.data?.id;
        history.push(`/budget/${newBudgetId}`);
        setLoading(false);
        addSnack({
          message: BUDGET_UPDATE_MESSAGE,
        });
      })
      .catch((error) => {
        if (data?.hasOwnProperty("budgetPhases")) {
          data.budgetPhases = sparebudgetPhases;
        }
        handleError(error)
      });
  };

  const handleAddPhase = () => {
    const addData = {
      id: ++idNum,
      new: true,
      code: null,
      displayName: "",
      budgetAmount: "",
    };
    const date = [...data?.budgetPhases, addData];
    setData({ ...data, budgetPhases: date });
  };

  const handleRemoveClick = (id) => {
    const filteredData = data?.budgetPhases?.filter((row) => row?.id !== id);
    setData({ ...data, budgetPhases: filteredData });
  };

  const handleInputChangeBudgetPhase = (name, value, id) => {
    /*This function is calling under loop so when this function called we are getting
    the item index and then checking if the name is budgetAmount and it's value is empty so we are putting
    the validation message on particular index's budget amount and else we are setting the data for submit*/
    if (name === 'budgetAmount' && !value) {
      if (phaseItemsError?.indexOf(i => i.rowIndex === id) === -1) {
        setPhaseItemsError([...phaseItemsError, {
          name: 'budgetAmount',
          error: true,
          message: 'Required',
          rowIndex: id
        }]);
      }
    } else {
      if (name === 'budgetAmount') {
        /* IN this else when value is correct so here we are checking if the value is there and
        the error message still there so we are removing the error message here*/
        const UpdatedPhaseItemsError = [...phaseItemsError]
        const itemToRemoveIndex = UpdatedPhaseItemsError?.findIndex(function (item) {
          return item?.rowIndex === id;
        });
        if (itemToRemoveIndex !== -1) {
          UpdatedPhaseItemsError?.splice(itemToRemoveIndex, 1);
        }
        setPhaseItemsError(UpdatedPhaseItemsError);
      }
    }
    const itemIndex = data?.budgetPhases?.findIndex(function (item) {
      return item?.id === id;
    });
    const updatedBudgetPhases = JSON.parse(JSON.stringify(data?.budgetPhases));
    if (name === 'code') {
      updatedBudgetPhases[itemIndex]['displayName'] = JSON.parse(value)?.description;
    }
    if (name === 'budgetAmount') {
      updatedBudgetPhases[itemIndex]['budgetAmount'] = Math.trunc((parseFloat(value) + Number.EPSILON) * 100) / 100
      let updatedData = JSON.parse(JSON.stringify(data));
      updatedData = { ...updatedData, budgetPhases: updatedBudgetPhases }
      setData(updatedData);
      return
    }
    updatedBudgetPhases[itemIndex][name] = value;
    let updatedData = JSON.parse(JSON.stringify(data));
    updatedData = { ...updatedData, budgetPhases: updatedBudgetPhases }
    setData(updatedData);
  };

  const isBudgetPhasesValid = (list, savedList) => {
    if (list === undefined || list?.length < 1) {
      return false;
    }
    let flag = false;

    if (mode === "create") {
      list?.map((item, i) => {
        flag = item.budgetAmount !== "" && item?.budgetAmount > 0 && item?.code !== '' && item?.displayName !== ''
        return flag === true;
      });
    } else {
      if (savedList?.length > 0) {
        if (savedList?.length !== list?.length) {
          return true;
        }
        list?.map((item, i) => {
          if (!item?.new) {
            flag = item?.id !== savedList[i]?.id &&
              item?.budgetAmount !== '' &&
              item?.budgetAmount !== savedList[i]?.budgetAmount &&
              item?.code !== '' &&
              item?.code !== savedList[i]?.code &&
              item?.displayName !== '' &&
              item?.displayName !== savedList[i]?.displayName
            return flag === true;
          } else {
            flag = item?.budgetAmount !== '' &&
              item?.code !== '' &&
              item?.displayName !== ''
            return flag === true;
          }
        });
      } else {
        list?.map((item, i) => {
          flag = item.budgetAmount !== "" && item?.budgetAmount > 0 && item?.code !== '' && item?.displayName !== ''
          return flag === true;
        });
      }
    }
    return flag
  }

  let isDirty = false;
  if (budgetId === "0") {
    isDirty = data?.budgetName &&
      data?.matter?.matterId &&
      (data?.timePeriod === BUDGET_LABELS.LIFE_OF_MATTER || data?.timePeriod === BUDGET_LABELS.CUSTOM_DATE_RANGE_LABEL && data?.fiscalYear !== '') &&
      (data?.budgetType?.toLowerCase() === 'total' && data?.budgetAmount || data?.budgetType?.toLowerCase() === 'phase' && isBudgetPhasesValid(data?.budgetPhases));
  } else {
    isDirty = detailData?.budgetName !== data?.budgetName ||
      detailData?.budgetAmount !== data?.budgetAmount ||
      detailData?.timePeriod !== data?.timePeriod ||
      (detailData?.budgetType?.toLowerCase() === 'total' && detailData?.budgetAmount !== data?.budgetAmount
        || detailData?.budgetType?.toLowerCase() === 'phase' && isBudgetPhasesValid(data?.budgetPhases, detailData?.budgetPhases))
  }

  const isValid = data?.budgetName !== "" && data?.organization !== "" && data?.matter?.matterId !== "" &&
    (data?.budgetType?.toLowerCase() === 'total' && data?.budgetAmount || data?.budgetType?.toLowerCase() === 'phase' && isBudgetPhasesValid(data?.budgetPhases)) &&
    (data?.timePeriod === BUDGET_LABELS.LIFE_OF_MATTER || (data?.timePeriod === BUDGET_LABELS.CUSTOM_DATE_RANGE_LABEL));


  return (
    <div className={classes.container}>
      <Detail
        mode={mode}
        setMode={setMode}
        breadcrumbValues={[]}
        subject={title.edit}
        newTitle={title.create}
        onCreate={onSubmitHandle}
        onUpdate={onUpdateHandler}
        onCancel={() => history.goBack()}
        loading={loading}
        isValid={renderTernary(Object.keys(errors).length > 0, false, isValid)}
        isDirty={renderTernary(Object.keys(errors).length > 0, false, isDirty)}
        className={classes.container}
        hideDeleteBtn={true}
        editBtnTxt={SUBMIT}
        cancelText={DISCARD}
      // footerActions={<div>Version {mode === "edit" ? data?.version+1 : '1.00'}</div>}
      >
        <Heading as="h3" size="large" UNSAFE_className={classes.budgetDetailsHeading}>
          Budget Details
        </Heading>
        <Grid>
          <GridColumn sm={7}>
            <div className={classes.leftContent}>
              <div
                className={[classes.columnSpacing, classes.divBorder].join(" ")}
                data-testid="budgetDetails"
              >
                <Grid>
                  <GridColumn sm={12}>
                    <Label text={BUDGET_NAME} mandatoryField />
                    {loading || dataLoading ?
                      <Skeleton height="58px" variant="rectangle" />
                      :
                      <MuiTextField
                        value={data?.budgetName}
                        data-testid="budget-name"
                        helperText={errors?.budgetName && <MuiValidationMessage message={errors?.budgetName?.message} />}
                        inputProps={{
                          id: "budgetName",
                          name: "budgetName",
                        }}
                        type="text"
                        fullWidth={true}
                        error={errors?.budgetName}
                        disabled
                      />
                    }
                  </GridColumn>
                </Grid>
              </div>
              <div
                className={[classes.columnSpacing, classes.divBorder].join(" ")}
                data-testid="timePeriod"
              >
                <Heading as="h3" size="large" UNSAFE_className={classes.subTitle}>
                  Time Period*
                </Heading>
                {loading || dataLoading ?
                  <Skeleton height="58px" variant="rectangle" />
                  :
                  <FormGroup>
                    <Radio
                      label="Life of Matter"
                      name="timePeriod"
                      value={BUDGET_LABELS.LIFE_OF_MATTER}
                      id="life-of-matter"
                      checked={data?.timePeriod === BUDGET_LABELS.LIFE_OF_MATTER}
                      data-testid="time-period-life_of_matter"
                      onChange={(e) =>
                        handleInputChange(e.target.name, e.target.value)
                      }
                    />

                    <Radio
                      label={BUDGET_LABELS.FISCAL_YEAR_FY}
                      name="timePeriod"
                      id="fiscal-year"
                      value={BUDGET_LABELS.CUSTOM_DATE_RANGE_LABEL}
                      checked={data?.timePeriod === BUDGET_LABELS.CUSTOM_DATE_RANGE_LABEL}
                      data-testid="time-period-fiscal-year"
                      onChange={(e) =>
                        handleInputChange(e.target.name, e.target.value)
                      }
                    />
                  </FormGroup>
                }
                {loading || dataLoading ?
                  <Skeleton height="58px" variant="rectangle" />
                  :
                  (data?.timePeriod === BUDGET_LABELS.CUSTOM_DATE_RANGE_LABEL && (
                    <div
                      className={classes.timePeriodSpacingTop}
                      data-testid="fiscal-year"
                    >
                      <Grid>
                        <GridColumn sm={10}>
                          <Select
                            value={data?.fiscalYear}
                            onChange={(e) => {
                              handleInputChange(
                                "fiscalYear",
                                e.target.value
                              );
                            }}>
                            <option value="">Select Fiscal Year</option>
                            {tenYears?.map((item) => <option key={item.slice(0, 6)} value={item.slice(0, 6)}>{item}</option>)}
                          </Select>
                        </GridColumn>
                      </Grid>
                    </div>
                  ))}
              </div>
              <div
                className={[classes.columnSpacing, classes.divBorder].join(" ")}
                data-testid="budgetType"
              >
                <Heading as="h3" size="large" UNSAFE_className={classes.subTitle}>
                  Type*
                </Heading>
                <div className={classes.flexGrid}>
                  {loading || dataLoading ?
                    <Skeleton height="58px" variant="rectangle" />
                    :
                    <FormGroup>
                      <Radio
                        label="Total"
                        name="budgetType"
                        checked={data?.budgetType?.toLowerCase() === "total"}
                        value="Total"
                        data-testid="budget-total-radio"
                        onChange={(e) =>
                          handleInputChange(e.target.name, e.target.value)
                        }
                        disabled={mode === "edit"}
                      />
                      <Radio
                        label="Phase"
                        id="budgetTypePhase"
                        name="budgetType"
                        checked={data?.budgetType?.toLowerCase() === "phase"}
                        data-testid="budget-phase-radio"
                        value="Phase"
                        onChange={(e) =>
                          handleInputChange(e.target.name, e.target.value)
                        }
                        disabled={mode === "edit"}
                      />
                    </FormGroup>
                  }

                  {data?.budgetType?.toLowerCase() === "total" && (
                    <div
                      className={classes.budgetTypeTotal}
                      data-testid="budget-total"
                    >
                      <Grid>
                        <GridColumn sm={12}>
                          <Label text={BUDGET_AMOUNT} mandatoryField />
                          {loading || dataLoading ?
                            <Skeleton height="58px" variant="rectangle" />
                            :
                            <MuiTextField
                              id="amount-wrap"
                              value={data?.budgetAmount}
                              data-testid="budget-input-amount"
                              pattern="[0,9]*"
                              helperText={errors?.budgetAmount && <MuiValidationMessage message={errors?.budgetAmount?.message} />}
                              inputProps={{
                                id: "budgetAmount",
                                name: "budgetAmount"
                              }}
                              InputProps={{
                                startAdornment: <InputAdornment position="start"><span>$</span></InputAdornment>,
                                endAdornment: <InputAdornment position="end"><span>USD</span></InputAdornment>,
                              }}
                              leadingIcon={<span>$</span>}
                              trailing={"USD"}
                              type="number"
                              onKeyDown={(e) => onInputNumberKeyDown(e)}
                              fullWidth={true}
                              {...register(
                                'budgetAmount',
                                { ...budgetDetailValidationRules?.budgetAmount, onChange: (e) => { handleInputChange(e.target.name, e.target.value) } }
                              )}
                              error={errors?.budgetAmount}
                            />
                          }
                        </GridColumn>
                      </Grid>
                    </div>
                  )}

                  {data?.budgetType?.toLowerCase() === "phase" && (
                    <div
                      className={classes.budgetTypePhase}
                      data-testid="budget-phase"
                    >
                      {loading || dataLoading ?
                        <Skeleton height="58px" variant="rectangle" />
                        : <>
                          <div className={classes.addPhase}>
                            <div
                              className={classes.cursorPointer}
                              data-testid="budget_phase_addPhase"
                              id="budget_phase_addPhase"
                              onClick={handleAddPhase}
                            >
                              <Plus size="medium" />
                              <span className={classes.addNewText}>Add Phase</span>
                            </div>
                          </div>

                          <Grid UNSAFE_style={{ flex: 1 }}>
                            <div className={classes.overviewTableHeader}>
                              <GridColumn
                                className={classes.overviewTableHeaderRow}
                                sm={3}
                              >
                                Code
                              </GridColumn>
                              <GridColumn
                                className={classes.overviewTableHeaderRow}
                                sm={6}
                              >
                                {DESCRIPTION}
                              </GridColumn>
                              <GridColumn
                                className={classes.overviewHeaderRowRight}
                                sm={2}
                              >
                                $ Budget Amount
                              </GridColumn>
                              <GridColumn
                                className={classes.overviewHeaderRowRight}
                                sm={1}
                              ></GridColumn>
                            </div>
                            {data?.budgetPhases ? data?.budgetPhases?.map((item) => {
                              const showError = phaseItemsError?.find(x => x?.name === 'budgetAmount' && x?.rowIndex === item?.id);
                              return (<div className={classes.overviewTableBody} key={item?.id}>
                                <GridColumn
                                  className={item?.new ? classes.overviewTableBodyRowEdit : classes.overviewTableBodyRow}
                                  sm={3}
                                >
                                  {item?.new ?
                                    <UtbmsActivityAutocomplete
                                      name="code"
                                      value={item?.code}
                                      setValue={setUtbmsCode}
                                      data={masterDetails ? sortByString([...masterDetails?.expenseCode?.masterData, ...masterDetails?.phaseCode?.masterData, ...masterDetails?.taskCode?.masterData], "value") : []}
                                      placeholder="Enter Code"
                                      handleBlur={() => { }}
                                      showDescription={false}
                                      codeId={item?.id}
                                      selectedValues={data?.budgetPhases}
                                      fromBudget={true}
                                      mode={mode}
                                    />
                                    : (
                                      item?.code
                                    )}
                                </GridColumn>
                                <GridColumn
                                  className={item?.new ? classes.overviewTableBodyRowEdit : classes.overviewTableBodyRow}
                                  sm={6}
                                >
                                  {item?.new ?
                                    <MuiTextField
                                      value={item?.displayName}
                                      disabled={true}
                                      data-testid="budget_phase_displayName"
                                      id="displayName"
                                      placeholder="Enter Description"
                                      name="displayName"
                                      onChange={(e) => { handleInputChangeBudgetPhase(e.target.name, e.target.value, item?.id) }}
                                      type="text"
                                      fullWidth={true}
                                      className={classes.textFieldTop}
                                    />
                                    : (
                                      item?.displayName
                                    )}
                                </GridColumn>
                                <GridColumn
                                  className={item?.new ? classes.overviewBodyRowRightEdit : classes.overviewBodyRowRight}
                                  sm={2}
                                >
                                  {item?.new ?
                                    <MuiTextField
                                      value={item?.budgetAmount}
                                      placeholder="Amount"
                                      data-testid="budget_phase_budgetAmount"
                                      id="budgetAmountNew"
                                      name="budgetAmount"
                                      error={showError?.error}
                                      helperText={showError?.error && <MuiValidationMessage message={'Required'} />}
                                      onChange={(e) => { handleInputChangeBudgetPhase(e.target.name, e.target.value, item?.id) }}
                                      onKeyDown={(e) => onInputNumberKeyDown(e)}
                                      type="number"
                                      fullWidth={true}
                                      className={classes.textFieldTop}
                                    />
                                    : (
                                      item["budgetAmount"]
                                    )}
                                </GridColumn>
                                <GridColumn
                                  className={classes.overviewTableBodyRowRemove}
                                  sm={1}
                                >
                                  <Button
                                    variant="tertiary"
                                    onClick={() => handleRemoveClick(item?.id)}
                                    data-testid={`budget_phase_remove`}
                                  >
                                    {REMOVE}
                                  </Button>
                                </GridColumn>
                              </div>
                              )
                            }) : <></>}
                          </Grid>
                        </>
                      }
                    </div>
                  )}
                </div>
              </div>
            </div>
          </GridColumn>
          <GridColumn sm={5}>
            <div className={classes.contentSpacingOrg}>
              <Label text={ORGANIZATION} mandatoryField />
              {loading || dataLoading ?
                <Skeleton height="58px" variant="rectangle" />
                :
                <div className={classes.contentSpacing16}>
                  {companyName}
                </div>
              }
            </div>
            <div
              className={[classes.columnSpacing, classes.divBorder].join(" ")}
              data-testid="budgetMatter"
            >
              <div>
                <Label text={MATTER} mandatoryField />
                {loading || dataLoading ?
                  <Skeleton height="58px" variant="rectangle" />
                  :
                  <MatterAutocomplete
                    value={data?.matter}
                    required={true}
                    setValue={(value) => {
                      handleInputChange("matter", value)
                    }}
                    disabled={fromMatter || mode === "edit"}
                    register={register}
                    errors={errors}
                    name={"matter"}
                    validationRules={budgetDetailValidationRules}
                    isRestricted={false}
                    fetchAllSensitiveMatters={true}
                  />
                }
              </div>
            </div>
          </GridColumn>
        </Grid>
      </Detail>
      <SubmitBudgetModal
        open={submitModalOpen}
        setOpen={setSubmitModalOpen}
        onCloseModal={onCloseModal}
        title={BUDGET_LABELS.EXISTING_BUDGET}
        submitButtonText={PROCEED}
        onSubmit={onCreateHandler}
        submitLoading={loading}
        budgetData={existingBudgetData}
      />
    </div>
  );
};

export default CreateEditBudget;
